import { useState, useEffect } from 'react';
import { DataMappingsApi } from '../../clients';

export const useDataMappingsForUpload = () => {
  const [dataMappingsForUpload, setDataMappingsNames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDataMappings = async () => {
      const response = await DataMappingsApi.getDataMappingsForUpload();
      setDataMappingsNames(response.data);
      setLoading(false);
    };
    fetchDataMappings();
  }, [loading]);

  return { dataMappingsForUpload, loading };
};
